import type { ZodiacSign } from '@/api/consts'

export { ZodiacSign } from '@/api/consts'

export type ObjectInfo = {
  type: PlanetType | ObjectType
  sign: ZodiacSign
  house: number | null
  degrees: number
  minutes: number
  lon: number
  retrograde: boolean
}

export type NatalChart = {
  objects: ObjectInfo[]
  aspects: NatalAspect[]
}

export type NatalAspect = {
  planet1: PlanetType | ObjectType
  planet2: PlanetType | ObjectType
  aspect: AspectType
  orb: number
}

export type Transit = {
  importance: number
  transitPlanet: PlanetType
  natalPlanet: PlanetType
  aspect: AspectType
  natalLon: number
  transitLon: number
  orb: number
  date: number
}

export enum PlanetType {
  SUN = 'SUN',
  MOON = 'MOON',
  MERCURY = 'MERCURY',
  VENUS = 'VENUS',
  MARS = 'MARS',
  JUPITER = 'JUPITER',
  SATURN = 'SATURN',
  URANUS = 'URANUS',
  NEPTUNE = 'NEPTUNE',
  PLUTO = 'PLUTO',
}

export enum ObjectType {
  ASC = 'ASC',
  MC = 'MC',
  NORTH_NODE = 'NORTH_NODE',
  LILITH = 'LILITH',
  CHIRON = 'CHIRON',
}

export enum AspectType {
  CONJUNCTION = 0,
  SEXTILE = 60,
  SQUARE = 90,
  TRINE = 120,
  OPPOSITION = 180,
}
